export function pageNavigation() {
  const nav = document.querySelector('[data-page-navigation-menu]');
  if (!nav) return;

  const links = [...nav.querySelectorAll('a')];
  if (!links.length) return;

  const sections = links
    .map(link => document.getElementById(link.getAttribute('href').substring(1)))
    .filter(Boolean);
  if (!sections.length) return;

  let headerOffset = 0;
  let currentIndex = null;
  let clickTargetIndex = null;

  const offsetElements = [
    document.querySelector('.main-header'),
    nav,
  ].filter(Boolean);

  function updateOffset() {
    headerOffset = offsetElements.reduce((sum, el) => sum + el.offsetHeight, 0);
    sections.forEach(section => {
      section.style.scrollMarginTop = `${headerOffset}px`;
    });
  }

  const resizeObserver = new ResizeObserver(updateOffset);
  offsetElements.forEach(el => resizeObserver.observe(el));
  updateOffset();

  function getTop(el) {
    return el.getBoundingClientRect().top + window.scrollY;
  }

  function getRanges() {
    return sections.map((section, i) => ({
      top: getTop(section),
      bottom: i < sections.length - 1
        ? getTop(sections[i + 1])
        : getTop(section) + section.offsetHeight,
    }));
  }

  function scrollToActive(index) {
    const link = links[index];
    if (!link) return;
    const paddingLeft = parseFloat(getComputedStyle(nav).paddingLeft);
    nav.scrollLeft = link.offsetLeft - paddingLeft;
  }

  function setActive(index) {
    links[currentIndex]?.classList.remove('active');
    links[index]?.classList.add('active');
    currentIndex = index;
    if (index !== null) scrollToActive(index);
  }

  links.forEach((link, index) => {
    link.addEventListener('click', () => {
      clickTargetIndex = index;
      setActive(index);
    });
  });

  function getBestIndex(ranges, viewTop, viewBottom) {
    const tolerance = 2;
    for (let i = 0; i < ranges.length; i++) {
      const range = ranges[i];
      if (range.top >= viewTop - tolerance && range.bottom <= viewBottom + tolerance) {
        return i;
      }
    }

    let bestIndex = currentIndex;
    let bestPixels = 0;
    ranges.forEach((range, i) => {
      const pixels = Math.max(0, Math.min(range.bottom, viewBottom) - Math.max(range.top, viewTop));
      if (pixels > bestPixels) {
        bestPixels = pixels;
        bestIndex = i;
      }
    });

    return bestIndex;
  }

  const observer = new IntersectionObserver(
    () => {
      const ranges = getRanges();
      const viewTop = window.scrollY + headerOffset;
      const viewBottom = window.scrollY + window.innerHeight;

      if (clickTargetIndex !== null) {
        const target = ranges[clickTargetIndex];
        const targetPixels = Math.max(0, Math.min(target.bottom, viewBottom) - Math.max(target.top, viewTop));
        const best = getBestIndex(ranges, viewTop, viewBottom);
        if (best === clickTargetIndex && targetPixels > 0) {
          clickTargetIndex = null;
        } else {
          return;
        }
      }

      const activeIndex = getBestIndex(ranges, viewTop, viewBottom);
      if (activeIndex !== currentIndex) setActive(activeIndex);
    },
    {
      rootMargin: `-${headerOffset}px 0px 0px 0px`,
      threshold: Array.from({ length: 100 }, (_, i) => i / 100),
    }
  );

  sections.forEach(section => observer.observe(section));
}